import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useEffect } from 'react';

const css = `
  .pricing * { margin: 0; padding: 0; box-sizing: border-box; }
  .pricing {
    font-family: 'Inter', sans-serif;
    background: #fafaf8;
    color: #1a1a2e;
    min-height: 100vh;
    overflow-x: hidden;
    --purple: #5c4d96;
    --green: #5aaa8a;
    --text: #1a1a2e;
    --muted: #5a5a7a;
  }

  /* Nav */
  .pricing nav {
    position: sticky; top: 0; z-index: 100;
    display: flex; align-items: center; justify-content: space-between;
    padding: 20px 32px;
    background: rgba(250,250,248,0.85);
    backdrop-filter: blur(16px); -webkit-backdrop-filter: blur(16px);
    border-bottom: 1px solid rgba(0,0,0,0.06);
  }
  .pricing .logo {
    font-size: 22px; font-weight: 800; color: #5c4d96;
    text-decoration: none; cursor: pointer;
  }
  .pricing .nav-right { display: flex; align-items: center; gap: 24px; }
  .pricing .nav-link {
    font-size: 14px; font-weight: 500; color: #5a5a7a;
    text-decoration: none; cursor: pointer; transition: color 0.2s;
  }
  .pricing .nav-link:hover { color: #5c4d96; }
  .pricing .nav-signin {
    padding: 9px 22px; border-radius: 20px;
    background: rgba(124,107,196,0.08); border: 1px solid rgba(124,107,196,0.2);
    color: #5c4d96; font-weight: 600; font-size: 14px;
    text-decoration: none; cursor: pointer; transition: background 0.2s;
  }
  .pricing .nav-signin:hover { background: rgba(124,107,196,0.14); }

  /* Hero */
  .pricing .hero {
    text-align: center;
    padding: 80px 24px 60px;
  }
  .pricing .hero h1 {
    font-size: clamp(36px, 5vw, 56px); font-weight: 800;
    letter-spacing: -1.5px; line-height: 1.08; margin-bottom: 16px;
  }
  .pricing .hero h1 .accent {
    background: linear-gradient(135deg, #5c4d96, #5aaa8a);
    -webkit-background-clip: text; -webkit-text-fill-color: transparent;
  }
  .pricing .hero p { font-size: 18px; color: #5a5a7a; max-width: 440px; margin: 0 auto; line-height: 1.6; }

  /* Toggle */
  .pricing .toggle-wrap {
    display: flex; align-items: center; justify-content: center; gap: 12px;
    margin: 36px auto 0;
    font-size: 14px; font-weight: 500; color: #5a5a7a;
  }
  .pricing .toggle {
    position: relative; width: 44px; height: 24px;
    background: #5c4d96; border-radius: 12px; cursor: pointer;
    transition: background 0.2s;
  }
  .pricing .toggle::after {
    content: ''; position: absolute;
    top: 3px; left: 3px;
    width: 18px; height: 18px; border-radius: 50%;
    background: white; transition: transform 0.2s;
  }
  .pricing .toggle.annual::after { transform: translateX(20px); }
  .pricing .save-badge {
    background: rgba(90,170,138,0.12); color: #5aaa8a;
    font-size: 12px; font-weight: 700; padding: 3px 10px; border-radius: 20px;
  }

  /* Cards */
  .pricing .cards {
    display: flex; gap: 24px; justify-content: center; align-items: stretch;
    max-width: 720px; margin: 56px auto 0; padding: 0 24px;
    flex-wrap: wrap;
  }
  .pricing .card {
    flex: 1; min-width: 260px; max-width: 320px;
    background: white; border: 1px solid rgba(0,0,0,0.08);
    border-radius: 24px; padding: 32px 28px;
    display: flex; flex-direction: column;
    box-shadow: 0 4px 24px rgba(0,0,0,0.05);
    transition: transform 0.2s, box-shadow 0.2s;
  }
  .pricing .card:hover { transform: translateY(-4px); box-shadow: 0 12px 40px rgba(0,0,0,0.10); }
  .pricing .card.featured {
    border: 2px solid #5c4d96;
    background: linear-gradient(160deg, #faf9ff 0%, #fff 100%);
    box-shadow: 0 8px 40px rgba(124,107,196,0.18);
    position: relative;
  }
  .pricing .featured-badge {
    position: absolute; top: -13px; left: 50%; transform: translateX(-50%);
    background: linear-gradient(135deg, #5c4d96, #9b8ae8);
    color: white; font-size: 11px; font-weight: 700;
    padding: 4px 16px; border-radius: 20px; white-space: nowrap;
    letter-spacing: 0.5px;
  }
  .pricing .plan-name {
    font-size: 13px; font-weight: 700; letter-spacing: 1.5px;
    text-transform: uppercase; color: #5a5a7a; margin-bottom: 12px;
  }
  .pricing .card.featured .plan-name { color: #5c4d96; }
  .pricing .price {
    font-size: 48px; font-weight: 800; letter-spacing: -2px;
    color: #1a1a2e; line-height: 1; margin-bottom: 4px;
  }
  .pricing .price sup { font-size: 22px; font-weight: 700; vertical-align: super; letter-spacing: 0; }
  .pricing .price-period { font-size: 13px; color: #5a5a7a; margin-bottom: 8px; }
  .pricing .price-annual { font-size: 12px; color: #5aaa8a; font-weight: 600; margin-bottom: 24px; min-height: 18px; }
  .pricing .plan-desc { font-size: 14px; color: #5a5a7a; line-height: 1.6; margin-bottom: 24px; }
  .pricing .divider { height: 1px; background: rgba(0,0,0,0.06); margin-bottom: 24px; }
  .pricing .features-list { list-style: none; display: flex; flex-direction: column; gap: 12px; flex: 1; margin-bottom: 28px; }
  .pricing .features-list li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 14px; color: #1a1a2e; line-height: 1.4;
  }
  .pricing .features-list li::before {
    content: '✓'; font-size: 13px; font-weight: 800; flex-shrink: 0; margin-top: 1px;
  }
  .pricing .card:not(.featured) .features-list li::before { color: #5aaa8a; }
  .pricing .card.featured .features-list li::before { color: #5c4d96; }
  .pricing .features-list li.muted { color: #aaa; }
  .pricing .features-list li.muted::before { content: '–'; color: #ccc; }
  .pricing .cta-btn {
    display: block; text-align: center; padding: 13px 24px;
    border-radius: 20px; font-weight: 700; font-size: 15px;
    text-decoration: none; cursor: pointer; transition: transform 0.15s, box-shadow 0.15s;
    border: none;
  }
  .pricing .cta-btn.outline {
    background: transparent; border: 1.5px solid rgba(124,107,196,0.3); color: #5c4d96;
  }
  .pricing .cta-btn.outline:hover { background: rgba(124,107,196,0.06); }
  .pricing .cta-btn.solid {
    background: #5c4d96; color: white;
    box-shadow: 0 4px 16px rgba(124,107,196,0.35);
  }
  .pricing .cta-btn.solid:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(124,107,196,0.4); }
  .pricing .cta-btn.green {
    background: #5aaa8a; color: white;
    box-shadow: 0 4px 16px rgba(90,170,138,0.3);
  }
  .pricing .cta-btn.green:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(90,170,138,0.4); }

  /* FAQ */
  .pricing .faq {
    max-width: 680px; margin: 100px auto 0; padding: 0 24px;
  }
  .pricing .faq h2 {
    font-size: 32px; font-weight: 800; letter-spacing: -1px;
    text-align: center; margin-bottom: 40px;
  }
  .pricing .faq-item {
    border-bottom: 1px solid rgba(0,0,0,0.07); padding: 20px 0;
  }
  .pricing .faq-q {
    font-size: 15px; font-weight: 600; color: #1a1a2e;
    cursor: pointer; display: flex; justify-content: space-between; align-items: center; gap: 16px;
  }
  .pricing .faq-q::after { content: '+'; font-size: 20px; font-weight: 400; color: #5c4d96; flex-shrink: 0; }
  .pricing .faq-a {
    font-size: 14px; color: #5a5a7a; line-height: 1.7; margin-top: 12px; display: none;
  }
  .pricing .faq-item.open .faq-q::after { content: '–'; }
  .pricing .faq-item.open .faq-a { display: block; }

  /* Footer */
  .pricing footer {
    text-align: center; padding: 60px 24px 40px;
    font-size: 13px; color: #5a5a7a; opacity: 0.6;
    border-top: 1px solid rgba(0,0,0,0.06); margin-top: 100px;
    display: flex; flex-direction: column; align-items: center; gap: 8px;
  }
  .pricing .footer-links { display: flex; gap: 16px; }
  .pricing .footer-links a { color: #5a5a7a; text-decoration: none; }
  .pricing .footer-links a:hover { color: #5c4d96; }

  @media (max-width: 768px) {
    .pricing .cards { flex-direction: column; align-items: center; }
    .pricing .card { max-width: 100%; width: 100%; }
    .pricing nav { padding: 16px 20px; }
    .pricing .nav-link { display: none; }
  }
`;

const sharedFeatures = [
  'SOAP note generation',
  'CPT & ICD-10 billing codes',
  'Apple Watch recording',
  'Plan presets & templates',
  'Voice agent assistant',
  'Priority support',
];

const plans = [
  {
    name: 'Free',
    price: 0,
    annualNote: '',
    desc: 'Try AirScribe. No credit card required.',
    limit: '10 encounters / month',
    cta: 'Get started free',
    ctaStyle: 'outline',
    featured: false,
  },
  {
    name: 'Pro',
    price: 29,
    annualNote: 'Save $72/yr with annual billing',
    desc: 'For clinicians who document daily.',
    limit: 'Unlimited encounters',
    cta: 'Start 14-day free trial',
    ctaStyle: 'solid',
    featured: true,
  },
];

const faqs = [
  { q: 'Is the free plan really free?', a: "Yes — no credit card required. You get 10 encounters per month on the Free plan, forever. When you're ready to scale up, upgrading takes less than a minute." },
  { q: 'What counts as an encounter?', a: 'Each recorded and processed session counts as one encounter. Replaying or editing a previous encounter does not count against your limit.' },
  { q: 'Can I cancel anytime?', a: "Absolutely. Cancel from your account settings at any time. If you're on an annual plan, you keep access until the end of the billing period." },
  { q: 'Does AirScribe integrate with my EHR?', a: 'Direct EHR integrations (Epic, Athena, Healthie) are on the roadmap. PDF export is available today.' },
  { q: 'Is patient data secure?', a: 'AirScribe is built with HIPAA-compliant infrastructure. Audio and transcripts are encrypted in transit and at rest. We do not use your clinical data to train models.' },
];

export default function PricingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!document.querySelector('link[href*="Inter"]')) {
      const link = document.createElement('link');
      link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap';
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }

    // FAQ accordion
    const items = document.querySelectorAll('.pricing .faq-item');
    const handleClick = (item: Element) => () => item.classList.toggle('open');
    const handlers: Array<() => void> = [];
    items.forEach(item => {
      const h = handleClick(item);
      handlers.push(h);
      item.querySelector('.faq-q')?.addEventListener('click', h);
    });
    return () => {
      items.forEach((item, i) => item.querySelector('.faq-q')?.removeEventListener('click', handlers[i]));
    };
  }, []);

  const goTo = (path: string) => (e: React.MouseEvent) => { e.preventDefault(); navigate(path); };

  return (
    <Box className="pricing">
      <style>{css}</style>

      <nav>
        <div className="logo" onClick={goTo('/')}>AirScribe</div>
        <div className="nav-right">
          <a className="nav-link" href="/pricing" onClick={goTo('/pricing')}>Pricing</a>
          <a className="nav-signin" href="/login" onClick={goTo('/login')}>Sign In</a>
        </div>
      </nav>

      <main>
      <div className="hero">
        <h1>Simple pricing,<br /><span className="accent">no surprises.</span></h1>
        <p>Start free. Upgrade when you're ready. Cancel anytime.</p>
      </div>

      <div className="cards">
        {plans.map(plan => (
          <div key={plan.name} className={`card${plan.featured ? ' featured' : ''}`}>
            {plan.featured && <div className="featured-badge">Most Popular</div>}
            <div className="plan-name">{plan.name}</div>
            <div className="price">
              {plan.price === 0 ? 'Free' : <><sup>$</sup>{plan.price}</>}
            </div>
            {plan.price > 0 && <div className="price-period">/ month</div>}
            <div className="price-annual">{plan.annualNote}</div>
            <div className="plan-desc">{plan.desc}</div>
            <div className="divider"></div>
            <ul className="features-list">
              <li>{plan.limit}</li>
              {sharedFeatures.map(f => <li key={f}>{f}</li>)}
            </ul>
            <a
              href="/login"
              className={`cta-btn ${plan.ctaStyle}`}
              onClick={goTo('/login')}
            >
              {plan.cta}
            </a>
          </div>
        ))}
      </div>

      <div className="faq">
        <h2>Common questions</h2>
        {faqs.map(({ q, a }) => (
          <div key={q} className="faq-item">
            <div className="faq-q">{q}</div>
            <div className="faq-a">{a}</div>
          </div>
        ))}
      </div>

      </main>

      <footer>
        <div>&copy; 2026 AirScribe. All rights reserved.</div>
        <div className="footer-links">
          <a href="/legal/privacy" onClick={goTo('/legal/privacy')}>Privacy Policy</a>
          <a href="/legal/tos" onClick={goTo('/legal/tos')}>Terms of Service</a>
        </div>
      </footer>
    </Box>
  );
}
